import $ from 'jquery';
import Swiper, { Autoplay, Pagination } from 'swiper';
Swiper.use([Autoplay, Pagination]);

export default class Testimonials {
    constructor() {
        if ($('.js-testimonial-slider').length) {
            const testimonialSlider = new Swiper('.js-testimonial-slider', {
                autoHeight: true,
                autoplay: {
                    delay: 5000,
                },
                loop: $(this).find('.swiper-slide').length > 1 ? true : false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                watchOverflow: true
            });
        };
    }
}
